var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwoCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 311,
    height: 174,
    viewBox: "0 0 311 174",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "people_love_us_icon3",
    transform: "translate(66 -1702)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_172533",
    "data-name": "\\uADF8\\uB8F9 172533",
    transform: "translate(0 -35)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_172083",
    "data-name": "\\uADF8\\uB8F9 172083",
    transform: "translate(-55 1736.781)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uD0C0\\uC6D0_16987",
    "data-name": "\\uD0C0\\uC6D0 16987",
    transform: "translate(67 0.219)",
    fill: "none",
    stroke: "#dde5ef",
    strokeWidth: 21
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 76.5,
    cy: 76.5,
    r: 76.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76.5,
    cy: 76.5,
    r: 66,
    fill: "none"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_16988",
    "data-name": "\\uD0C0\\uC6D0 16988",
    cx: 76.5,
    cy: 76.5,
    r: 76.5,
    transform: "translate(-11 0.219)",
    fill: "#dde5ef"
  })), /*#__PURE__*/React.createElement("g", {
    id: "company1-1",
    transform: "translate(50 1814)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_321",
    "data-name": "\\uD0C0\\uC6D0 321",
    cx: 3.5,
    cy: 3.5,
    r: 3.5,
    transform: "translate(0)",
    fill: "#d2dce9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_325",
    "data-name": "\\uD0C0\\uC6D0 325",
    cx: 3.5,
    cy: 3.5,
    r: 3.5,
    transform: "translate(27)",
    fill: "#d2dce9"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "\\uD0C0\\uC6D0_329",
    "data-name": "\\uD0C0\\uC6D0 329",
    cx: 3,
    cy: 3.5,
    rx: 3,
    ry: 3.5,
    transform: "translate(54)",
    fill: "#d2dce9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_333",
    "data-name": "\\uD0C0\\uC6D0 333",
    cx: 3.5,
    cy: 3.5,
    r: 3.5,
    transform: "translate(81)",
    fill: "#d2dce9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_337",
    "data-name": "\\uD0C0\\uC6D0 337",
    cx: 3.5,
    cy: 3.5,
    r: 3.5,
    transform: "translate(107)",
    fill: "#d2dce9"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "\\uD0C0\\uC6D0_341",
    "data-name": "\\uD0C0\\uC6D0 341",
    cx: 3,
    cy: 3.5,
    rx: 3,
    ry: 3.5,
    transform: "translate(135)",
    fill: "#d2dce9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_345",
    "data-name": "\\uD0C0\\uC6D0 345",
    cx: 3.5,
    cy: 3.5,
    r: 3.5,
    transform: "translate(161)",
    fill: "#d2dce9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_349",
    "data-name": "\\uD0C0\\uC6D0 349",
    cx: 3.5,
    cy: 3.5,
    r: 3.5,
    transform: "translate(188)",
    fill: "#d2dce9"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "\\uD0C0\\uC6D0_322",
    "data-name": "\\uD0C0\\uC6D0 322",
    cx: 3.5,
    cy: 3,
    rx: 3.5,
    ry: 3,
    transform: "translate(0 24)",
    fill: "#d2dce9"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "\\uD0C0\\uC6D0_326",
    "data-name": "\\uD0C0\\uC6D0 326",
    cx: 3.5,
    cy: 3,
    rx: 3.5,
    ry: 3,
    transform: "translate(27 24)",
    fill: "#d2dce9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_330",
    "data-name": "\\uD0C0\\uC6D0 330",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(54 24)",
    fill: "#d2dce9"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "\\uD0C0\\uC6D0_334",
    "data-name": "\\uD0C0\\uC6D0 334",
    cx: 3.5,
    cy: 3,
    rx: 3.5,
    ry: 3,
    transform: "translate(81 24)",
    fill: "#d2dce9"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "\\uD0C0\\uC6D0_338",
    "data-name": "\\uD0C0\\uC6D0 338",
    cx: 3.5,
    cy: 3,
    rx: 3.5,
    ry: 3,
    transform: "translate(107 24)",
    fill: "#d2dce9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_342",
    "data-name": "\\uD0C0\\uC6D0 342",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(135 24)",
    fill: "#d2dce9"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "\\uD0C0\\uC6D0_346",
    "data-name": "\\uD0C0\\uC6D0 346",
    cx: 3.5,
    cy: 3,
    rx: 3.5,
    ry: 3,
    transform: "translate(161 24)",
    fill: "#d2dce9"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "\\uD0C0\\uC6D0_350",
    "data-name": "\\uD0C0\\uC6D0 350",
    cx: 3.5,
    cy: 3,
    rx: 3.5,
    ry: 3,
    transform: "translate(188 24)",
    fill: "#d2dce9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_323",
    "data-name": "\\uD0C0\\uC6D0 323",
    cx: 3.5,
    cy: 3.5,
    r: 3.5,
    transform: "translate(0 47)",
    fill: "#d2dce9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_327",
    "data-name": "\\uD0C0\\uC6D0 327",
    cx: 3.5,
    cy: 3.5,
    r: 3.5,
    transform: "translate(27 47)",
    fill: "#d2dce9"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "\\uD0C0\\uC6D0_331",
    "data-name": "\\uD0C0\\uC6D0 331",
    cx: 3,
    cy: 3.5,
    rx: 3,
    ry: 3.5,
    transform: "translate(54 47)",
    fill: "#d2dce9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_335",
    "data-name": "\\uD0C0\\uC6D0 335",
    cx: 3.5,
    cy: 3.5,
    r: 3.5,
    transform: "translate(81 47)",
    fill: "#d2dce9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_339",
    "data-name": "\\uD0C0\\uC6D0 339",
    cx: 3.5,
    cy: 3.5,
    r: 3.5,
    transform: "translate(107 47)",
    fill: "#d2dce9"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "\\uD0C0\\uC6D0_343",
    "data-name": "\\uD0C0\\uC6D0 343",
    cx: 3,
    cy: 3.5,
    rx: 3,
    ry: 3.5,
    transform: "translate(135 47)",
    fill: "#d2dce9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_347",
    "data-name": "\\uD0C0\\uC6D0 347",
    cx: 3.5,
    cy: 3.5,
    r: 3.5,
    transform: "translate(161 47)",
    fill: "#d2dce9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_351",
    "data-name": "\\uD0C0\\uC6D0 351",
    cx: 3.5,
    cy: 3.5,
    r: 3.5,
    transform: "translate(188 47)",
    fill: "#d2dce9"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "\\uD0C0\\uC6D0_324",
    "data-name": "\\uD0C0\\uC6D0 324",
    cx: 3.5,
    cy: 3,
    rx: 3.5,
    ry: 3,
    transform: "translate(0 71)",
    fill: "#d2dce9"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "\\uD0C0\\uC6D0_328",
    "data-name": "\\uD0C0\\uC6D0 328",
    cx: 3.5,
    cy: 3,
    rx: 3.5,
    ry: 3,
    transform: "translate(27 71)",
    fill: "#d2dce9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_332",
    "data-name": "\\uD0C0\\uC6D0 332",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(54 71)",
    fill: "#d2dce9"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "\\uD0C0\\uC6D0_336",
    "data-name": "\\uD0C0\\uC6D0 336",
    cx: 3.5,
    cy: 3,
    rx: 3.5,
    ry: 3,
    transform: "translate(81 71)",
    fill: "#d2dce9"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "\\uD0C0\\uC6D0_340",
    "data-name": "\\uD0C0\\uC6D0 340",
    cx: 3.5,
    cy: 3,
    rx: 3.5,
    ry: 3,
    transform: "translate(107 71)",
    fill: "#d2dce9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_344",
    "data-name": "\\uD0C0\\uC6D0 344",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(135 71)",
    fill: "#d2dce9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_348",
    "data-name": "\\uD0C0\\uC6D0 348",
    cx: 3.5,
    cy: 3.5,
    r: 3.5,
    transform: "translate(161 90)",
    fill: "#d2dce9"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwoCircle);
export default __webpack_public_path__ + "static/media/twoCircle.97c3b791a370925a0e73c6163bebdf61.svg";
export { ForwardRef as ReactComponent };